import React from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";
import { FormattedMessage } from "react-intl";
import { formatNumber, getApiLimitSuffix } from "utils";
import { MAX_API_RECORDS } from "constants/index";
import { Grid } from "components/Containers";
import ProgressMenu from "components/ProgressMenu";
import { Spinner } from "components/Loader";

/**
 * ApplicantListTabs
 *
 * @param {Array}     applicantTabs
 * @param {Object}    count
 * @param {Boolean}   loading
 * @param {Number}    selectedProgressMenu
 * @param {Function}  setSelectedProgressMenu
 */
const ApplicantListTabs = ({ applicantTabs, count, loading, selectedProgressMenu, setSelectedProgressMenu }) => (
  <Grid>
    <Grid.col start={1} end={13}>
      <ProgressMenu
        items={transformData(applicantTabs, count, loading)}
        selected={selectedProgressMenu}
        onSelect={setSelectedProgressMenu}
      />
    </Grid.col>
    <Grid.col start={1} end={13}>
      <hr />
    </Grid.col>
  </Grid>
);

const transformData = (tabs, counts, loading) => tabs.map((item) => renderMenuTitle(item, counts, loading));

const renderMenuTitle = (item, counts, loading) => {
  // Handle nested arrays
  if (Array.isArray(item)) return { subItems: transformData(item, counts, loading) };

  // Helper to render count with fallback
  const Count = () =>
    loading ? (
      <Spinner size="1rem" />
    ) : [undefined, null].includes(counts[item.countField]) ? (
      <></>
    ) : (
      <div css={styles.count}>
        ({formatNumber(counts[item.countField], getApiLimitSuffix(counts[item.countField], MAX_API_RECORDS))})
      </div>
    );

  // Handle top-level objects
  return {
    label: <FormattedMessage id={item.title} values={{ count: <Count /> }} />,
    disabled: item.disabled,
  };
};

const styles = {
  count: css`
    font-weight: 400;
  `,
};

ApplicantListTabs.propTypes = {
  applicantTabs: PropTypes.array,
  count: PropTypes.object,
  loading: PropTypes.bool,
  selectedProgressMenu: PropTypes.number,
  setSelectedProgressMenu: PropTypes.func,
};

export default ApplicantListTabs;
